import { watchDeleteDisplayConfig } from './deleteDisplayConfig';
import { watchFetchDisplayConfigs } from './fetchDisplayConfigs';
import { watchUpdateDisplayConfig } from './updateDisplayConfig';

export const displaySagas = [watchFetchDisplayConfigs(), watchDeleteDisplayConfig(), watchUpdateDisplayConfig()];
